import type { FaireProductEntity } from "../../entity_types/product";

export const p_t3t2df48w2: FaireProductEntity = {
  token: "p_t3t2df48w2",
  type: "product",
  name: 'Female Torso Planter-9"H-431',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/8b9f625a277e67574bb8653c5b570de028a48d6e944982fcbf7b06ec23395dec.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f35d70ce950791dfbe938f468ba3904b5b9355733c4304747f9301c4c79231b2.jpeg",
    "https://cdn.faire.com/fastly/032cfd0070bc98bcf3b3cfd2c0cc3403a2445af69037a4efef7a6ec2799419a5.jpeg",
  ],
  priceDollars: 27.5,
  description:
    "Bring a touch of ancient Greece to your home or garden with this stunning Female Torso Planter. Crafted out of cement, this beautifully sculpted planter evokes classic Grecian and Roman art lost to antiquity — and makes a wonderful home for your favorite plants or flowers. Other styles and sizes are also available.",
  tags: [],
  msrpDollars: 55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:16.488Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
